import axios from "axios";
import Errores from "@/utils/Errores";
let loguearUsuario = async (credenciales, componente, gCaptchaToken) => {
  let login = await axios
    .post(API.REGISTRO + "cuenta/login", credenciales, gCaptchaToken)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      Errores.switchErrors(error, componente, [
        {
          codigo: 503,
          mensaje:
            "El periodo de postulación ha finalizado. Infórmate sobre las próximas etapas en <a href='https://www.sistemadeadmisionescolar.cl'>www.sistemadeadmisionescolar.cl</a>"
        }
      ]);
      return null;
    });
  return login;
};

let solicitudCambioClave = async (usuario, componente, gCaptchaToken) => {
  let solicitud = await axios
    .post(API.REGISTRO + "solicitud-cambio-clave", usuario, gCaptchaToken)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      Errores.switchErrors(error, componente);
      return null;
    });
  return solicitud;
};

let cambiarClave = async (datos, componente) => {
  let solicitud = await axios
    .put(API.REGISTRO + "cuenta/cambio-clave", datos)
    .then(resp => {
      return true;
    })
    .catch(error => {
      Errores.switchErrors(error, componente);
      return false;
    });
  return solicitud;
};

export default {
  loguearUsuario,
  solicitudCambioClave,
  cambiarClave
};



// WEBPACK FOOTER //
// ./src/services/ApiLogin.js